import React, { useContext } from "react";
import styled from "styled-components";

import { Toolbar } from "@examspark/common-ui";

import Button from "../common/Button";
import { ExamContext } from "../exam/context/examContext";

import Modal from "./Modal";

//todo: swap these to common-ui
const PrimaryButton = styled(Button)`
  background-color: #006699;
  color: white;
  border: none;
  cursor: pointer;
  text-transform: uppercase;
  font-weight: bold;

  &:hover {
    background-color: #0170a7;
  }
`;
const SecondaryButton = styled(Button)`
  background-color: #e7e7e7;
  color: #333;
  display: flex;
  align-items: center;
  font-weight: bold;
  text-transform: uppercase;
  height: 4rem;
  transform: background-color 0.2s;

  &:hover {
    background-color: #e0e0e0;
  }
`;
const StyledMessage = styled.div`
  padding: 2rem;
`;

type SaveAndExitModalProps = {
  onExit?: () => void;
  isTeacherPaused?: boolean;
};
export const SaveAndExitModal = (props: SaveAndExitModalProps) => {
  const [state, dispatch] = useContext(ExamContext);

  return (
    <Modal
      isOpen={state.isPausedWithExitPrompt || false}
      title="Activity Saved"
      onRequestClose={() => {
        dispatch({
          type: "SET_PAUSED_WITH_EXIT_PROMPT",
          value: false,
        });
      }}
      buttons={
        <Toolbar>
          <SecondaryButton
            disabled={props.isTeacherPaused}
            onClick={() =>
              dispatch({
                type: "SET_PAUSED_WITH_EXIT_PROMPT",
                value: false,
              })
            }
          >
            <div style={{ padding: "1.5rem 1rem" }}>Resume</div>
          </SecondaryButton>
          <PrimaryButton
            disabled={props.isTeacherPaused}
            onClick={() => props.onExit?.()}
          >
            <div style={{ padding: "1.5rem 1rem" }}>Exit</div>
          </PrimaryButton>
        </Toolbar>
      }
    >
      <StyledMessage>
        Your assessment has been saved. Click Exit to close this assessment, or
        click Resume to continue.
      </StyledMessage>
    </Modal>
  );
};
